import { useField } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { DateSelect } from "./DateSelect";
import { DateSelectFieldProps, DateSelectValue } from "./types";
import {
  validateDateSegments,
  parseISODateAsDateSelectValue,
  formatDateSelectValueAsISODate,
} from "./utils";
import { InputWrapper } from "../../../components/inputs/_assets/input-wrapper/InputWrapper";

/**
 * @deprecated use DateSelectFormikField instead
 */
export function DateSelectField({
  name,
  span = "auto",
  testID = "date-select-field",
  ...props
}: DateSelectFieldProps) {
  const [field, meta, helpers] = useField(name);
  const [date, setDate] = useState<DateSelectValue>();
  const { t } = useTranslation();

  // builds custom error message bypassing Yup & Formik
  // component is composed of two input fields but one Formik field
  const partialDateErrorMessage = validateDateSegments(
    t,
    date,
    props.label,
    props.isApproximateDate
  );

  useEffect(() => {
    const newValue = parseISODateAsDateSelectValue(field.value);

    if (newValue) {
      setDate(newValue);
    }
  }, [field.value]);

  useEffect(() => {
    const isoDate = formatDateSelectValueAsISODate(
      date,
      props.isApproximateDate
    );

    if (isoDate) {
      helpers.setValue(isoDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  return (
    <InputWrapper span={span} testID={`${testID}-container`}>
      <DateSelect
        testID={testID}
        validationState={meta.touched && meta.error ? "invalid" : "valid"}
        errorMessage={meta.touched && (partialDateErrorMessage || meta.error)}
        {...props}
        value={date}
        onChange={setDate}
        onBlur={() => {
          helpers.setTouched(true);
        }}
      />
    </InputWrapper>
  );
}
